"use client";
import ToolsGrid from "@/components/ToolsGrid";
import { tools as originalTools } from "@/app/[locale]/data/tools";
import { useTranslations } from "next-intl";
import { useMemo } from "react";
import RelatedFinders from "@/components/ShadeFinder/RelatedFinders";

export default function Content() {
  const t = useTranslations("tools");

  const tools = useMemo(() =>
    originalTools.map((tool) => {
      // Map tool titles to translation keys
      const titleKey = tool.title
        .replace(/\s+/g, "")
        .replace(/AI/g, "ai")
        .replace(/Free/g, "free")
        .charAt(0).toLowerCase() + tool.title
        .replace(/\s+/g, "")
        .replace(/AI/g, "ai")
        .replace(/Free/g, "free")
        .slice(1);

      const descKey = titleKey + "Desc";
      const buttonKey = tool.buttonText
        .replace(/\s+/g, "")
        .charAt(0).toLowerCase() + tool.buttonText
        .replace(/\s+/g, "")
        .slice(1);

      return {
        ...tool,
        title: t(titleKey),
        description: t(descKey),
        buttonText: t(buttonKey),
      };
    }),
    [t]
  );

  return <><RelatedFinders source="/tools" /><ToolsGrid tools={tools} /></>;
}
